import React from "react";
import { observer } from "mobx-react";
import ibsStore from "./Stores/IbsSurveyStore";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import store from "./Stores/IbsSurveyStore";
import SurveyTitleArea from "./SurveyTitleArea";
import SurveyContentContainer from "./SurveyContentContainer";
import SurveyPage from "./SurveyPage";
import classNames from "classnames";
import '../Styling/recentActivities.css';
import {Product} from "../Enums/ibsConstants";
import SurveySection from "./SurveySection";
import {Chart} from "react-google-charts";
import SurveyElement from "./SurveyElement";

import Highcharts, { getOptions } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const RecentActivitiesPage = observer((props) => {
    if (ibsStore.currentSurvey) {
        if(ibsStore.currentSurvey.ProductID == 1) {
            if (!window.location.href.includes('/db')) {
                window.location.href = '/db/recentActivities'
            }
        } else if (ibsStore.currentSurvey.ProductID == 2) {
            if (!window.location.href.includes('/dc')) {
                window.location.href = '/dc/recentActivities'
            }
        }
    }

    let content;
    const isAnalyst = ibsStore.accountInfo?.UserRoleID == 3;
    if (isAnalyst) {
        content =
            <SurveyPage noFooter={true}>
                <SurveyTitleArea pageName="RecentActivities" />
                <SurveyContentContainer>
                    <div className={classNames("fade-in")}>
                        <RecentActivities />
                        <Statistics/>
                    </div>
                </SurveyContentContainer>
            </SurveyPage>;   
    } else {
        content = (
            <>
                You are not allowed to view this page.
            </>
        )
    }

    return content;
});




const RecentActivities = observer(() => {
    const recentActivityList = [];
    ibsStore.recentActivityList?.forEach(activity => {
        let product = "DB";
        switch (activity.ProductID)
        {
            case Product.DB:
                product = "DB";
                break;
            case Product.DC:
                product = "DC";
                break;
            case Product.VB:
                product = "Pensioenbeheer";
                break;
        }

        let editedDate = new Date(activity?.LatestActivity ?? null);
        let currentDate = new Date();
        let dateText = "";

        /* form a date string describing how long ago the survey had activity */
        if (typeof activity.LatestActivity !== "undefined" && activity?.LatestActivity !== null && editedDate && currentDate) {
            let differenceSeconds = (currentDate - editedDate) / 1000.0;
            let differenceMinutes = differenceSeconds / 60.0;
            let differenceHours = differenceMinutes / 60.0;
            ;
            if (differenceSeconds < 1) {
                dateText = "less than a second ago"
            }
            else if (differenceMinutes < 1) {
                dateText = Math.round(differenceSeconds).toString() + " second" + (Math.round(differenceSeconds) > 1 ? "s":"") + " ago"
            }
            else if (differenceHours < 1) {
                dateText = Math.round(differenceMinutes).toString() + " minute" + (Math.round(differenceMinutes) > 1 ? "s" : "") + " ago"
            }
            else {
                dateText = Math.round(differenceHours).toString() + " hour" + (Math.round(differenceHours) > 1 ? "s" : "") + " ago"
            }
        }

        recentActivityList.push(
            <li>{activity.PlanSponsor} updated their {product}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ fontSize: "13px", color: "darkgrey" }}>{dateText}</span>
            </li>);
    });
    
    const encodeForGChart = (surveySubmissionsByDate) => {
        let result = [];
        
        const date30DaysAgo = new Date();
        date30DaysAgo.setMonth(date30DaysAgo.getMonth() - 1);
        date30DaysAgo.setHours(0, 0, 0);
        
        result.push(["Date", "Submissions"])
        surveySubmissionsByDate.forEach(ssbd => {
            if(date30DaysAgo <= ssbd.DateCompletedWithoutTime)
                result.push([ssbd.DateCompletedWithoutTime, ssbd.Submissions])
        })
        
        return result;
    }
    
    let dbLast30DaySubmissionsChart = <>No Data</>;
    let dcLast30DaySubmissionsChart = <>No Data</>;
    if(store.surveySubmissionsByDate) {
        const width = "400";
        const height = "80";
        if(store.surveySubmissionsByDate[Product.DB].length > 0)
            dbLast30DaySubmissionsChart = (
                <Chart chartType={"Line"}
                       data={encodeForGChart(store.surveySubmissionsByDate[Product.DB])}
                       width={width}
                       height={height}
                       options={{legend: { position: 'none' }}}
                />
            )
        
        if(store.surveySubmissionsByDate[Product.DC].length > 0)
            dcLast30DaySubmissionsChart = (
                <Chart chartType={"Line"}
                       data={encodeForGChart(store.surveySubmissionsByDate[Product.DC])}
                       width={width}
                       height={height}
                       options={{legend: { position: 'none' }}}
                />
            )
    }
    return (
        <>
            <SurveySection labelText="Recent Activities">
                <Container fluid>
                    <Row>
                        <Col md={6} sm={12} xs={12}>
                            <SurveyElement labelText="Last 30 Days" />
                            Defined Benefit submissions:
                            {dbLast30DaySubmissionsChart}
                            <br />
                            Defined Contributions submissions:
                            {dcLast30DaySubmissionsChart}
                        </Col>
                        <Col md={6} sm={12} xs={12}>
                            <SurveyElement labelText="Today" />
                            <ul>
                                {recentActivityList}
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </SurveySection>
        </>
    )
})


const Statistics = observer(() => {

    var statusDonePercentDB = (store.productStatsDB.StatusDone * 100 / store.productStatsDB.TotalSurveys).toFixed(0);
    var statusNeedsWorkPercentDB = (store.productStatsDB.StatusNeedsWork * 100 / store.productStatsDB.TotalSurveys).toFixed(0);
    var statusWebValidatedPercentDB = (store.productStatsDB.StatusWebValidated * 100 / store.productStatsDB.TotalSurveys).toFixed(0);
    var statusDontUsePercentDB = (store.productStatsDB.StatusDontUse * 100 / store.productStatsDB.TotalSurveys).toFixed(0);
    var statusSeeMemoPercentDB = (store.productStatsDB.StatusSeeMemo * 100 / store.productStatsDB.TotalSurveys).toFixed(0);
    var stillWorkingDB = ((store.productStatsDB.TotalSurveys - store.productStatsDB.SubmittedSurveys) * 100 / store.productStatsDB.TotalSurveys).toFixed(0);

    var webPercentDB = (store.productStatsDB.Web * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var excelPercentDB = (store.productStatsDB.Excel * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var templatesByCEMDB = (store.productStatsDB.TemplatesByCEM * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var templatesByClientDB = (store.productStatsDB.TemplatesByClient * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var templatesByThirdPartyDB = (store.productStatsDB.TemplatesByThirdParty * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var bnyMelonDB = (store.productStatsDB.BNYMelon * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var fidelityDB = (store.productStatsDB.Fidelity * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var ClientFilledDB = (store.productStatsDB.ClientFilled * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);
    var otherPercentDB = (store.productStatsDB.Other * 100 / store.productStatsDB.SubmittedSurveys).toFixed(0);

    var statusDonePercentDC = (store.productStatsDC.StatusDone * 100 / store.productStatsDC.TotalSurveys).toFixed(0);
    var statusNeedsWorkPercentDC = (store.productStatsDC.StatusNeedsWork * 100 / store.productStatsDC.TotalSurveys).toFixed(0);
    var statusWebValidatedPercentDC = (store.productStatsDC.StatusWebValidated * 100 / store.productStatsDC.TotalSurveys).toFixed(0);
    var statusDontUsePercentDC = (store.productStatsDC.StatusDontUse * 100 / store.productStatsDC.TotalSurveys).toFixed(0);
    var statusSeeMemoPercentDC = (store.productStatsDC.StatusSeeMemo * 100 / store.productStatsDC.TotalSurveys).toFixed(0);
    var stillWorkingDC = ((store.productStatsDC.TotalSurveys - store.productStatsDC.SubmittedSurveys) * 100 / store.productStatsDC.TotalSurveys).toFixed(0);

    var webPercentDC = (store.productStatsDC.Web * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var excelPercentDC = (store.productStatsDC.Excel * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var templatesByCEMDC = (store.productStatsDC.TemplatesByCEM * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var templatesByClientDC = (store.productStatsDC.TemplatesByClient * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var templatesByThirdPartyDC = (store.productStatsDC.TemplatesByThirdParty * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var bnyMelonDC = (store.productStatsDC.BNYMelon * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var fidelityDC = (store.productStatsDC.Fidelity * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var ClientFilledDC = (store.productStatsDC.ClientFilled * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);
    var otherPercentDC = (store.productStatsDC.Other * 100 / store.productStatsDC.SubmittedSurveys).toFixed(0);

    const optionsDB1 = {
        chart: {
            type: 'pie',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            plotBorderColor: '#fff',
            plotBorderWidth: 2,
        },
        plotOptions: {
            pie: {
                size: '80%',
                dataLabels: {
                    enabled: false
                }
            },
        },
        title: {
            text: 'DB Breakdown by Status:'
        },
        dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        series: [

            {
                name: 'DB Status',
                data: [
                    {
                        name: "Done",
                        y: store.productStatsDB.StatusDone ?? 0
                    },
                    {
                        name: "Needs Work",
                        y: store.productStatsDB.StatusNeedsWork ?? 0
                    },
                    {
                        name: "Web Validated",
                        y: store.productStatsDB.StatusWebValidated ?? 0
                    },
                    {
                        name: "Don't Use",
                        y: store.productStatsDB.StatusDontUse ?? 0
                    },
                    {
                        name: "See Memo",
                        y: store.productStatsDB.StatusSeeMemo ?? 0
                    },
                    {
                        name: "Still Working",
                        y: (store.productStatsDB.TotalSurveys - store.productStatsDB.SubmittedSurveys) ?? 0
                    }
                ]
            }
        ],
         credits: {
            enabled: false
        },
    };

    const optionsDB2 = {
        chart: {
            type: 'pie',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            plotBorderColor: '#fff',
            plotBorderWidth: 2,
        },
        plotOptions: {
            pie: {
                size: '80%',
                dataLabels: {
                    enabled: false
                }
            }
        },
        title: {
            text: 'DB Breakdown by Method of Submission:'
        },
        dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },

        series: [
            {
                name: 'DB Submission',
                data: [
                    {
                        name: "Web",
                        y: store.productStatsDB.Web ?? 0
                    },
                    {
                        name: "Excel",
                        y: store.productStatsDB.Excel ?? 0
                    },
                    {
                        name: "Templates (CEM collected)",
                        y: store.productStatsDB.TemplatesByCEM ?? 0
                    },
                    {
                        name: "Templates (Client collected)",
                        y: store.productStatsDB.TemplatesByClient ?? 0
                    },
                    {
                        name: "Templates (3rd Party collected)",
                        y: store.productStatsDB.TemplatesByThirdParty ?? 0
                    },
                    {
                        name: "Custodian",
                        y: store.productStatsDB.BNYMelon ?? 0
                    },
                    {
                        name: "Recordkeeper",
                        y: store.productStatsDB.Fidelity ?? 0
                    },
                    {
                        name: "Client Filled CEM Template",
                        y: store.productStatsDB.ClientFilled ?? 0
                    },
                    {
                        name: "Other",
                        y: store.productStatsDB.Other ?? 0
                    }
                ]
            }
        ],
        credits: {
            enabled: false
        }
    };

    const optionsDC1 = {
        chart: {
            type: 'pie',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            plotBorderColor: '#fff',
            plotBorderWidth: 2,
        },
        plotOptions: {
            pie: {
                size: '80%',
                dataLabels: {
                    enabled: false
                }
            }
        },
        title: {
            text: 'DC Breakdown by Status:'
        },
        dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },
        series: [

            {
                name: 'DC Status',
                data: [
                    {
                        name: "Done",
                        y: store.productStatsDC.StatusDone ?? 0
                    },
                    {
                        name: "Needs Work",
                        y: store.productStatsDC.StatusNeedsWork ?? 0
                    },
                    {
                        name: "Web Validated",
                        y: store.productStatsDC.StatusWebValidated ?? 0
                    },
                    {
                        name: "Don't Use",
                        y: store.productStatsDC.StatusDontUse ?? 0
                    },
                    {
                        name: "See Memo",
                        y: store.productStatsDC.StatusSeeMemo ?? 0
                    },
                    {
                        name: "Still Working",
                        y: (store.productStatsDC.TotalSurveys - store.productStatsDC.SubmittedSurveys) ?? 0
                    }
                ]
            }
        ],
        credits: {
            enabled: false
        }
    };
    const optionsDC2 = {
        chart: {
            type: 'pie',
            margin: [0, 0, 0, 0],
            spacingTop: 0,
            spacingBottom: 0,
            spacingLeft: 0,
            spacingRight: 0,
            plotBorderColor: '#fff',
            plotBorderWidth: 2,
        },
        plotOptions: {
            pie: {
                size: '80%',
                dataLabels: {
                    enabled: false
                }
            }
        },
        title: {
            text: 'DC Breakdown by Method of Submission:'
        },
        dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
        },
        tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
            point: {
                valueSuffix: '%'
            }
        },

        series: [
            {
                name: 'DC Submission',
                data: [
                    {
                        name: "Web",
                        y: store.productStatsDC.Web ?? 0
                    },
                    {
                        name: "Excel",
                        y: store.productStatsDC.Excel ?? 0
                    },
                    {
                        name: "Templates (CEM collected)",
                        y: store.productStatsDC.TemplatesByCEM ?? 0
                    },
                    {
                        name: "Templates (Client collected)",
                        y: store.productStatsDC.TemplatesByClient ?? 0
                    },
                    {
                        name: "Templates (3rd Party collected)",
                        y: store.productStatsDC.TemplatesByThirdParty ?? 0
                    },
                    {
                        name: "Custodian",
                        y: store.productStatsDC.BNYMelon ?? 0
                    },
                    {
                        name: "Recordkeeper",
                        y: store.productStatsDC.Fidelity ?? 0
                    },
                    {
                        name: "Client Filled CEM Template",
                        y: store.productStatsDC.ClientFilled ?? 0
                    },
                    {
                        name: "Other",
                        y: store.productStatsDC.Other ?? 0
                    } 
                ]
            }
        ],
        credits: {
            enabled: false
        }
    };

    let DB1_Flag = false;
    optionsDB1?.series[0]?.data?.forEach((val) => {
        let y = val.y ?? 0;
        if (typeof y === "number" && y > 0) { DB1_Flag = true; }
    });

    let DB2_Flag = false;
    optionsDB2?.series[0]?.data?.forEach((val) => {
        let y = val.y ?? 0;
        if (typeof y === "number" && y > 0) { DB2_Flag = true; }
    });

    let DC1_Flag = false;
    optionsDC1?.series[0]?.data?.forEach((val) => {
        let y = val.y ?? 0;
        if (typeof y === "number" && y > 0) { DC1_Flag = true; }
    });

    let DC2_Flag = false;
    optionsDC2?.series[0]?.data.forEach((val) => {
        let y = val.y ?? 0;
        if (typeof y === "number" && y > 0) { DC2_Flag = true; }
    });

    return (
        <React.Fragment>
            <SurveySection labelText="Statistics">
                {(DB1_Flag || DB2_Flag) && <SurveyElement labelText="<b>Defined Benefit</b>" />}
                {DB1_Flag && 
                    <div style={{ maxHeight: "20%", display: "flex", whiteSpace: "nowrap", float: "left" }}>
                        <div style={{ width: "15%", display: "inline-block", marginRight: "8%" }}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={optionsDB1}
                            />
                        </div>
                        <div style={{ alignItems: "center", display: "flex" }}>
                            <table style={{ display: "inline-block", borderCollapse: "collapse", border: "none" }}>
                                <tr style={{ borderBottom: "1px solid black", padding: "5px" }}>
                                    <th style={{ paddingRight: "30px" }} >Status</th>
                                    <th style={{ paddingLeft: "60px" }} >Count</th>
                                    <th style={{ paddingLeft: "60px" }} >%</th>
                                </tr>
                                <tr style={{ border: "none" }}>
                                    <td>Done</td>
                                    <td style={{ textAlign: "right" }}>{store.productStatsDB.StatusDone}</td>
                                    <td style={{ textAlign: "right" }}>{statusDonePercentDB} %</td>
                                </tr>
                                <tr style={{ border: "none" }}>
                                    <td>Needs Work</td>
                                    <td style={{ textAlign: "right" }}>{store.productStatsDB.StatusNeedsWork}</td>
                                    <td style={{ textAlign: "right" }}>{statusNeedsWorkPercentDB} %</td>
                                </tr>
                                <tr style={{ border: "none" }}>
                                    <td>Web Validated</td>
                                    <td style={{ textAlign: "right" }}>{store.productStatsDB.StatusWebValidated}</td>
                                    <td style={{ textAlign: "right" }}>{statusWebValidatedPercentDB} %</td>
                                </tr>
                                <tr style={{ border: "none" }}>
                                    <td>Don't Use</td>
                                    <td style={{ textAlign: "right" }}>{store.productStatsDB.StatusDontUse}</td>
                                    <td style={{ textAlign: "right" }}>{statusDontUsePercentDB} %</td>
                                </tr>
                                <tr style={{ border: "none" }}>
                                    <td>See Memo</td>
                                    <td style={{ textAlign: "right" }}>{store.productStatsDB.StatusSeeMemo}</td>
                                    <td style={{ textAlign: "right" }}>{statusSeeMemoPercentDB} %</td>
                                </tr>
                                <tr style={{ border: "none" }}>
                                    <td>Still Working </td>
                                    <td style={{ textAlign: "right" }}>{store.productStatsDB.TotalSurveys - store.productStatsDB.SubmittedSurveys}</td>
                                    <td style={{ textAlign: "right" }}>{stillWorkingDB} %</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                }

                {DB2_Flag &&
                    <div style={{ maxHeight: "20%", display: "flex", whiteSpace: "nowrap", float: "left" }}>
                        <div style={{ width: "15%", display: "inline-block", marginRight: "8%" }}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={optionsDB2}
                            />
                        </div>
                        <div style={{ alignItems: "center", display: "flex" }}>
                            <table style={{ display: "inline-block", borderCollapse: "collapse", border: "none" }}>
                            <tr style={{ borderBottom: "1px solid black", padding: "5px" }}>
                                <th style={{ paddingRight: "30px" }} >Status</th>
                                <th style={{ paddingLeft: "60px" }} >Count</th>
                                <th style={{ paddingLeft: "60px" }} >%</th>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Web</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.Web}</td>
                                <td style={{ textAlign: "right" }}>{webPercentDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Excel</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.Excel}</td>
                                <td style={{ textAlign: "right" }}>{excelPercentDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Templates (CEM collected)</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.TemplatesByCEM}</td>
                                <td style={{ textAlign: "right" }}>{templatesByCEMDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Templates (Client collected)</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.TemplatesByClient}</td>
                                <td style={{ textAlign: "right" }}>{templatesByThirdPartyDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Templates (3rd Party collected)</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.TemplatesByThirdParty}</td>
                                <td style={{ textAlign: "right" }}>{statusSeeMemoPercentDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Custodian</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.BNYMelon}</td>
                                <td style={{ textAlign: "right" }}>{bnyMelonDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Recordkeeper</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.Fidelity}</td>
                                <td style={{ textAlign: "right" }}>{fidelityDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Client filled CEM Template</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.ClientFilled}</td>
                                <td style={{ textAlign: "right" }}>{ClientFilledDB} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Other </td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDB.Other}</td>
                                <td style={{ textAlign: "right" }}>{otherPercentDB} %</td>
                            </tr>
                            </table>
                        </div>
                    </div>
                }
                {((DB1_Flag || DB2_Flag) && (DC1_Flag || DC2_Flag)) && <br />}
                {(DC1_Flag || DC2_Flag) && <SurveyElement labelText="<b>Defined Contribution</b>" />}
                {DC1_Flag && <div style={{ maxHeight: "20%", display: "flex", whiteSpace: "nowrap", float: "left" }}>
                    <div style={{ width: "15%", display: "inline-block", marginRight: "8%" }}>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={optionsDC1}
                        />
                    </div>
                    <div style={{ alignItems: "center", display: "flex" }}>
                        <table style={{ display: "inline-block", borderCollapse: "collapse", border: "none" }}>
                            <tr style={{ borderBottom: "1px solid black", padding: "5px" }}>
                                <th style={{ paddingRight: "30px" }} >Status</th>
                                <th style={{ paddingLeft: "60px" }} >Count</th>
                                <th style={{ paddingLeft: "60px" }} >%</th>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Done</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.StatusDone}</td>
                                <td style={{ textAlign: "right" }}>{statusDonePercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Needs Work</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.StatusNeedsWork}</td>
                                <td style={{ textAlign: "right" }}>{statusNeedsWorkPercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Web Validated</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.StatusWebValidated}</td>
                                <td style={{ textAlign: "right" }}>{statusWebValidatedPercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Don't Use</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.StatusDontUse}</td>
                                <td style={{ textAlign: "right" }}>{statusDontUsePercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>See Memo</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.StatusSeeMemo}</td>
                                <td style={{ textAlign: "right" }}>{statusSeeMemoPercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Still Working </td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.TotalSurveys - store.productStatsDC.SubmittedSurveys}</td>
                                <td style={{ textAlign: "right" }}>{stillWorkingDC} %</td>
                            </tr>
                        </table>
                    </div>
                </div>}
                {DC2_Flag &&
                    <div style={{ maxHeight: "20%", display: "flex", whiteSpace: "nowrap", float: "left" }}>
                        <div style={{ width: "15%", display: "inline-block", marginRight: "8%" }}>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={optionsDC2}
                            />
                        </div>
                        <div style={{ alignItems: "center", display: "flex" }}>
                            <table style={{ display: "inline-block", borderCollapse: "collapse", border: "none" }}>
                            <tr style={{ borderBottom: "1px solid black", padding: "5px" }}>
                                <th style={{ paddingRight: "30px" }} >Status</th>
                                <th style={{ paddingLeft: "60px" }} >Count</th>
                                <th style={{ paddingLeft: "60px" }} >%</th>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Web</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.Web}</td>
                                <td style={{ textAlign: "right" }}>{webPercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Excel</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.Excel}</td>
                                <td style={{ textAlign: "right" }}>{excelPercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Templates (CEM collected)</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.TemplatesByCEM}</td>
                                <td style={{ textAlign: "right" }}>{templatesByCEMDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Templates (Client collected)</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.TemplatesByClient}</td>
                                <td style={{ textAlign: "right" }}>{templatesByThirdPartyDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Templates (3rd Party collected)</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.TemplatesByThirdParty}</td>
                                <td style={{ textAlign: "right" }}>{statusSeeMemoPercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Custodian</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.BNYMelon}</td>
                                <td style={{ textAlign: "right" }}>{bnyMelonDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Recordkeeper</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.Fidelity}</td>
                                <td style={{ textAlign: "right" }}>{fidelityDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Other </td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.Other}</td>
                                <td style={{ textAlign: "right" }}>{otherPercentDC} %</td>
                            </tr>
                            <tr style={{ border: "none" }}>
                                <td>Client filled CEM Template</td>
                                <td style={{ textAlign: "right" }}>{store.productStatsDC.ClientFilled}</td>
                                <td style={{ textAlign: "right" }}>{ClientFilledDC} %</td>
                            </tr>
                            </table>
                        </div>
                    </div>}
            </SurveySection>        
        </React.Fragment>
    );
})


export default RecentActivitiesPage;